<template>
  <div class="p-the-c01-item-thumbnails-sp">
    <AppSwiper class="swiper" :options="swiperOption">
      <SwiperSlide v-for="(thumbnail, key) in thumbnails" :key="key">
        <img
          :src="thumbnail.image_url"
          class="p-the-c01-item-thumbnails-sp__img"
        />
      </SwiperSlide>
      <template v-slot:button-prev>
        <div class="js-button-prev p-the-c01-item-thumbnails-sp__toolbar__button">
          <IconBase
            view-box="0 0 24 24"
            width="16"
            height="16"
            icon-color="#b6b6b6"
          >
            <IconArrowLeft />
          </IconBase>
        </div>
      </template>
      <template v-slot:pagination>
        <div class="js-pagination p-the-c01-item-thumbnails-sp__toolbar__count"></div>
      </template>
      <template v-slot:button-next>
        <div class="js-button-next p-the-c01-item-thumbnails-sp__toolbar__button">
          <IconBase
            view-box="0 0 24 24"
            width="16"
            height="16"
            icon-color="#b6b6b6"
          >
            <IconArrowRight />
          </IconBase>
        </div>
      </template>
    </AppSwiper>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Swiper as SwiperClass, Pagination, Mousewheel } from "swiper";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft from "@/common/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";

// Swiper modules
SwiperClass.use([Pagination, Mousewheel]);

@Options({
  props: {
    thumbnails: { type: Array, required: true, default: () => [] }
  },
  components: {
    Swiper,
    SwiperSlide,
    IconBase,
    IconArrowLeft,
    IconArrowRight
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  },
  watch: {
    thumbnails() {
      this.initMain();
    }
  }
})
export default class TheC01ItemThumbnailsSp extends Vue {
  thumbnails!: any;
  colorCode!: string;

  main = "";
  swiperOption = {
    loop: true,
    speed: 350,
    pagination: {
      el: ".js-pagination",
      type: "fraction"
    },
    navigation: {
      nextEl: ".js-button-next",
      prevEl: ".js-button-prev"
    }
  };

  get haveThumnails() {
    return this.thumbnails.length > 0;
  }

  selectSub(sub: any) {
    this.main = sub;
  }
  selectedStyle(sub: any) {
    return this.main === sub ? `border: 1px solid ${this.colorCode}` : "";
  }
  initMain() {
    this.main = this.haveThumnails ? this.thumbnails[0] : {};
  }
}
</script>

<style lang="scss" scoped>
.p-the-c01-item-thumbnails-sp {
  position: relative;

  &__toolbar {
    position: absolute;
    bottom: 0;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: rem(248);
    left: 0;
    right: 0;
    margin: 0 auto;

    &__count {
      @include text__body--s;
      color: $common-black-sub;
      text-align: center;
    }
  }

  &__img {
    max-width: inherit;
    width: 100%;
  }
}
</style>
